import CMSPage from "./CMSPage.tsx";
import { PageContextValue, SiteContextValue } from "./engine/CMSComponent.tsx";
import type { RenderContext } from "./types.ts";
import "./styles.css";

export default function App({ renderContext }: { renderContext: RenderContext }) {
  const { pageModel, pageContext, site, year } = renderContext;

  return (
    <PageContextValue.Provider value={pageContext}>
      <SiteContextValue.Provider value={site}>
        <CMSPage
          pageModel={pageModel}
          site={site}
          year={year}
          render={({ header, body, footer, belowFooter }) => (
            <>
              {header}
              <main className="min-h-screen">{body}</main>
              {footer}
              {belowFooter}
            </>
          )}
        />
      </SiteContextValue.Provider>
    </PageContextValue.Provider>
  );
}
